/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {

    import IReportControlScope = Meevo.Plugins.Reports.IReportControlScope;

    interface IReportHelperStatic {
        reportShortCut: string;

        new(): IReportLogic;
    }

    export interface IReportLogic {
        properties: _.Dictionary<any>;
        buildLogic($scope: IReportControlScope): void;
    }

    class ReportLogicBase implements IReportLogic {

        protected _properties: _.Dictionary<any>;

        get properties() {
            return this._properties;
        }

        constructor() {
            this._properties = {};
        }

        buildLogic($scope: IReportControlScope) {
        }

    }


    class MA045Report extends ReportLogicBase implements IReportLogic {
        static reportShortCut: string = 'MA045';

        constructor() {
            super();

            this._properties.maxDate = moment()
				.add(-1,'month')//allow to select up to current month
                .endOf('month')
                .toDate();
        }
    }

    class DE070Report extends ReportLogicBase implements IReportLogic {
        static reportShortCut: string = 'DE070';

        buildLogic($scope: Meevo.Plugins.Reports.IReportControlScope) {
            if ($scope.parameterNames[0] === 'SortReportByDE070') {
                $scope.mainModel['SortReportByDE070'] = 'Employee';
            }

            if ($scope.parameterNames[0] === 'SortReportByDE070') {
                $scope.visibilityByControlNames.push({
                    controlName: 'viewReportBy',
                    valueToHide: 'SummaryView',
                });
            }

            if ($scope.parameterNames[0] === 'PageBreakOnSort') {
                $scope.visibilityByControlNames.push({
                    controlName: 'viewReportBy',
                    valueToHide: 'SummaryView',
                    nullValue: false
                });
            }

        }
    }

    export interface IReportLogicFactory {
        get(reportShortCut: string): IReportLogic;
    }

    class ReportLogicFactory implements IReportLogicFactory {

        static properties: IReportHelperStatic[] = [
            MA045Report,
            DE070Report
        ];

        static factory(): Function {
            const factory = () => new ReportLogicFactory();

            factory.$inject = [];

            return factory;
        }

        get(reportShortCut: string): IReportLogic {
            const PropertyStatic = ReportLogicFactory.properties.filter((pr) => pr.reportShortCut === reportShortCut)[0];

            return PropertyStatic ? new PropertyStatic() : new ReportLogicBase();
        }
    }

    angular.module('meevo.components.controls')
        .factory('meevo.components.controls.ReportLogicFactory', ReportLogicFactory.factory());
}
